import React from "react";
import styled from "styled-components";
import { BACKGROUND_DIM, BORDER_PRIMARY } from "@/constants/colors";
import { constants } from "@thecb/components";

export const Table = styled.table`
  width: 100%;
  table-layout: auto;
  ${({ extraStyles }) => extraStyles}
`;
const Tr = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid ${BORDER_PRIMARY};
  }

  ${({ hoverEffect }) =>
    hoverEffect &&
    `&:hover {
    cursor: pointer;
    background-color: ${constants.colors.HAWKES_BLUE};
  }`}

  ${({ extraStyles }) => extraStyles}
`;

// eventually these colors can be themed
// when we use this table for transaction search
// in profile
const Thead = styled.thead`
  background-color: ${BACKGROUND_DIM};
  border-bottom: 1px solid ${BORDER_PRIMARY};
  font-size: 0.875rem;
`;
export const TableHeader = ({ children, extraStyles = "" }) => (
  <Thead>
    <Tr extraStyles={extraStyles}>{children}</Tr>
  </Thead>
);

export const TableHeading = styled.th`
  padding: ${({ padding }) => padding || "16px 24px"};
  min-width: 100px;
  &:last-child {
    text-align: right;
  }
  ${({ extraStyles }) => extraStyles}
`;
export const TableBody = styled.tbody`
  ${({ extraStyles }) => extraStyles}
`;
export const TableRow = ({ children, onClick, extraStyles, ...props }) => (
  <Tr onClick={onClick} hoverEffect {...props} extraStyles={extraStyles}>
    {children}
  </Tr>
);

export const TableRowEntry = styled.td`
  padding: ${({ padding }) => (padding ? padding : "16px 24px")};
  font-size: 0.875rem;
  white-space: nowrap;
  min-width: ${({ minWidth }) => (minWidth ? minWidth : "75px")};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "250px")};
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ extraStyles }) => extraStyles};
`;
